import write from "../../assets/images/new-write.webp";
import datamellon from "../../assets/images/datamellon.webp";
import zaycodes from "../../assets/images/zay.webp";
import dash from "../../assets/images/dashlanguage.webp";
import dillivry from "../../assets/images/dilli.webp";
import songdis from "../../assets/images/songdis.png";
import insurance from "../../assets/images/insurance.png";
import befit from "../../assets/images/befit.png";
import portfolio from "../../assets/images/erin-v1.webp";
import erin from "../../assets/images/erin.webp";
import datamellonsmall from "../../assets/images/datamellon-small.png";
import writetechsmall from "../../assets/images/writetech-small.png";
import erinnewsmall from "../../assets/images/erin-new-small.png";
import zaysmall from "../../assets/images/zaycodes-small.png";
import dashsmall from "../../assets/images/dash-small.png";
import omsmall from "../../assets/images/om-small.png";
import psrsmall from "../../assets/images/psr-small.png";
import erinoldsmall from "../../assets/images/erin-small.png";
import dillivrysmall from "../../assets/images/dillivry-small.png";
import klaudworksbig from '../../assets/images/klaudworksbig.png'
import klaudworkssmall from '../../assets/images/klaudworkssmall.png'

export const workData = [
  {
    title: "Datamellon",
    description:
      "Datamellon is a leading software development company with a strong presence in Europe and Africa. They specialize in delivering simple, fast, and secure cloud solutions, making them an essential business partner at any stage of your digital transformation.",
    contribution_description:
      "I collaborated with a team of front-end developers to create the Datamellon project. My role also involved writing technical content for case studies and specialization contents on AWS solutions. This experience allowed me to contribute to the project's success and showcase my front-end development and technical writing skills.",
    live: "https://datamellon.com",
    img: datamellon,
    year: "2021",
    type: "image",
    slug: "datamellon",
    img_small: datamellonsmall,
  },
  {
    title: "BeFit Fitness GPT",
    description:
    "BeFit GPT is an AI-powered fitness coach that helps you stay consistent with your workouts, build healthier habits, and achieve your wellness goals. It gives you personalised routines, guidance, and motivation anytime you need it.",
    live: "https://admin-dev.datamellonai.com/mellyai/befit",
    img: befit,
    year: "2024",
    slug: "klaudworks",
    img_small: klaudworkssmall,
    type: "image",
    contribution_description: "In the Klaudworks project, I served as a front-end engineer, collaborating closely with a talented team of developers to create impactful, high-performance dashboards. My primary focus was on crafting a seamless user interface that enhanced user experience and increased engagement. These dashboards were designed to capture attention, resulting in a significant boost in site traffic and contributing to higher sales conversions."
    //   "I am responsible for building the front end, backend, and cloud architecture of the AptTraq app. This includes designing a user-friendly interface, ensuring robust backend functionality, and implementing a scalable and secure cloud infrastructure. This project showcases my full-stack development skills and ability to create comprehensive solutions from the ground up.",
  },
  {
    title: "Klaudworks",
    description:
      "Klaudworks, developed by Datamellon, is a comprehensive cost management and optimization tool similar to AWS Cost Explorer. It allows users to monitor, analyze, and manage their cloud costs and usage efficiently.",
    live: "https://klaudworks.io/",
    img: klaudworksbig,
    year: "2024",
    slug: "klaudworks",
    img_small: klaudworkssmall,
    type: "image",
    contribution_description: "In the Klaudworks project, I served as a front-end engineer, collaborating closely with a talented team of developers to create impactful, high-performance dashboards. My primary focus was on crafting a seamless user interface that enhanced user experience and increased engagement. These dashboards were designed to capture attention, resulting in a significant boost in site traffic and contributing to higher sales conversions."
    //   "I am responsible for building the front end, backend, and cloud architecture of the AptTraq app. This includes designing a user-friendly interface, ensuring robust backend functionality, and implementing a scalable and secure cloud infrastructure. This project showcases my full-stack development skills and ability to create comprehensive solutions from the ground up.",
  },
  {
    title: "SongDis",
    description:
    "SongDis is a music distribution platform that lets artists and creators release their songs to major streaming services and earn royalties directly. It’s a simple and powerful way to manage your music and get paid for it.",
    live: "https://songdis.com/",
    img: songdis,
    year: "2024",
    slug: "klaudworks",
    img_small: klaudworkssmall,
    type: "image",
    contribution_description: "In the Klaudworks project, I served as a front-end engineer, collaborating closely with a talented team of developers to create impactful, high-performance dashboards. My primary focus was on crafting a seamless user interface that enhanced user experience and increased engagement. These dashboards were designed to capture attention, resulting in a significant boost in site traffic and contributing to higher sales conversions."
    //   "I am responsible for building the front end, backend, and cloud architecture of the AptTraq app. This includes designing a user-friendly interface, ensuring robust backend functionality, and implementing a scalable and secure cloud infrastructure. This project showcases my full-stack development skills and ability to create comprehensive solutions from the ground up.",
  },
  {
    title: "Insurance Claims GPT",
    description:
    "Insurance Claims GPT is an AI assistant that helps people file, track, and manage their insurance claims. It automates most of the process, saving time, reducing stress, and making everything easier to follow.",
    live: "https://admin-dev.datamellonai.com/insurance-claim",
    img: insurance,
    year: "2024",
    slug: "klaudworks",
    img_small: klaudworkssmall,
    type: "image",
    contribution_description: "In the Klaudworks project, I served as a front-end engineer, collaborating closely with a talented team of developers to create impactful, high-performance dashboards. My primary focus was on crafting a seamless user interface that enhanced user experience and increased engagement. These dashboards were designed to capture attention, resulting in a significant boost in site traffic and contributing to higher sales conversions."
    //   "I am responsible for building the front end, backend, and cloud architecture of the AptTraq app. This includes designing a user-friendly interface, ensuring robust backend functionality, and implementing a scalable and secure cloud infrastructure. This project showcases my full-stack development skills and ability to create comprehensive solutions from the ground up.",
  },
  {
    title: "WriteTech Hub",
    description:
      "WriteTech Hub is a renowned brand in technical writing and open-source communities, dedicated to delivering exceptional technical communication. They believe that clear and precise technical communication is essential for innovation and progress. Their core services include Hosting Industry-Leading Technical Writing Events, Delivering High-Quality Technical Writing Services, Training Aspiring Technical Writers",
    // tools: [
    //   "Wordpress",
    // ],
    live: "https://writetechhub.org",
    img: write,
    type: "image",
    year: "2024",
    slug: "writetech",
    img_small: writetechsmall,
    contribution_description:
      "At WriteTech Hub, I built the website using Wordpress which acted as a Content Management System. I also contribute by providing high-quality technical writing services and supporting their mission of clear and precise communication. My work involves creating and refining technical documentation, participating in industry events, and assisting in training programs to nurture the next generation of technical writers.",
  },
  {
    title: "Zaycodes",
    description:
      "Zaycodes is the personal portfolio website of Zainab Daodu, a seasoned technical writer and ex software engineer. Zainab is passionate about enhancing technical documentation, contributing to open-source projects, and maintaining enterprise software applications. She is also a strong advocate for gender diversity and inclusion in the open-source community.",
    // tools: [
    //   "Wordpress",
    // ],
    live: "https://writetechhub.org",
    img: zaycodes,
    type: "image",
    year: "2024",
    slug: "zaycodes",
    img_small: zaysmall,
    contribution_description:
      "I built the Zaycodes website using WordPress. This platform allows Zainab to showcase her portfolio, blog about her experiences and insights, and connect with her audience effectively. The website reflects her professional achievements, advocacy efforts, and passion for technology and open source.",
  },
  {
    title: "Dash Language School",
    description:
      "This project involved creating a payment and informational platform for a language school based in Lagos, Nigeria. The website provides comprehensive information on the four foreign languages offered by the school and integrates a secure payment gateway (Paystack) for course enrollment.",
    // tools: [
    //   "ReactJs",
    //   "Redux",
    //   "Styled Components",
    //   "GSAP",
    //   "React Router",
    //   "Netlify",
    // ],
    live: "https://dashlanguageschool.com.ng",
    img: dash,
    type: "image",
    year: "2022",
    slug: "dash",
    img_small: dashsmall,
    contribution_description:
      "I led the development of the website application using React.js, implementing features that enhance user experience and facilitate secure transactions. Additionally, I wrote all the website content, ensuring clarity and accuracy in describing the language courses offered and their benefits to prospective students. This project highlights my expertise in frontend development and content creation for educational platforms.",
  },
  {
    title: "ERIN",
    description:
      "ERIN is a personal brand that focuses on Tech, Music, and Lifestyle. The brand aims to create innovative solutions that inspire and help build imaginations. By combining expertise in software development, music curation, and lifestyle content creation, ERIN offers a unique and engaging experience.",
    live: "https://jhimmyofficial.netlify.app",
    img: erin,
    type: "image",
    year: "2024",
    slug: "erin",
    img_small: erinnewsmall,
    contribution_description:
      "As the creator of the ERIN brand, I was responsible for building the website and writing all the website content. This involved designing a user-friendly interface, developing the site’s backend, and crafting engaging and informative content that reflects the brand’s vision and mission. This project showcases my skills in web development, content creation, and brand building.",
  },

//   {
//     title: "O.M Associates",
//     description:
//       "O.M.Associates is a multifaceted company offering accounting, taxation, audit & assurance, consulting, and CFO services. They provide comprehensive financial solutions to businesses and individuals, ensuring compliance and strategic financial management.",
//     // tools: ["ReactJs", "Redux", "Firebase", "React Router", "Netlify"],
//     live: "https://omassociates.com.ng/",
//     github: "https://github.com/OfficialJhimmy/om-new",
//     img: omassociates,
//     type: "image",
//     year: "2023",
//     slug: "om-associates",
//     img_small: omsmall,
//     contribution_description:
//       "I developed two versions of the O.M.Associates website: First Version (React): Built using React.js to provide a modern and responsive user interface. This version focused on delivering a dynamic and interactive browsing experience. Current Version (WordPress): Transitioned to WordPress to enhance content management capabilities.",
//   },

//   {
//     title: "Property Sales Reality",
//     description:
//       "Property Sales Reality is a platform designed to showcase available properties listed in Lagos, Nigeria. Users can filter properties based on criteria such as luxury, featured, for sale, and for rent. The platform includes an admin dashboard acting as the content management system (CMS) for managing property listings.",
//     // tools: ["ReactJs", "Redux", "Firebase", "React Router", "Netlify"],
//     live: "http://propertysalesreality.netlify.app/",
//     github: "https://github.com/OfficialJhimmy/Property-Sales-Reality",
//     img: psr,
//     type: "image",
//     year: "2022",
//     slug: "property-sales-reality",
//     img_small: psrsmall,
//     contribution_description:
//       "I developed the Property Sales Reality website using Firebase and React.js, leveraging these technologies to create a responsive and feature-rich platform for property listings. Additionally, I wrote all the website content, ensuring property descriptions were accurate and compelling.",
//   },

//   {
//     title: "ERIN Tech Portfolio v1",
//     description:
//     "ERIN is a personal brand that focuses on Tech, Music, and Lifestyle. The brand aims to create innovative solutions that inspire and help build imaginations. By combining expertise in software development, music curation, and lifestyle content creation, ERIN offers a unique and engaging experience.",
//     // tools: [
//     //   "ReactJs",
//     //   "GSAP",
//     //   "Swiper Js",
//     //   "React Router",
//     //   "Locomotive Scroll",
//     // ],
//     live: "http://jhimmyofficial.netlify.app",
//     github: "https://github.com/OfficialJhimmy/portfolio",
//     img: portfolio,
//     type: "image",
//     year: "2023",
//     slug: "portfolio-v1",
//     img_small: erinoldsmall,
//     contribution_description:
//     "As the creator of the ERIN brand, I was responsible for building the website and writing all the website content. This involved designing a user-friendly interface, developing the site’s backend, and crafting engaging and informative content that reflects the brand’s vision and mission. This project showcases my skills in web development, content creation, and brand building.",
//   },
  {
    title: "Dillivry",
    description:
      "Dillivry is a logistics company that facilitates package delivery by connecting senders with riders. The platform streamlines the process of sending packages, ensuring efficient and reliable delivery services.",
    // tools: [
    //   "ReactJs",
    //   "Redux",
    //   "Styled Components",
    //   "GSAP",
    //   "React Router",
    //   "Netlify",
    // ],
    live: "https://dillivry.com/",
    img: dillivry,
    type: "image",
    year: "2021",
    slug: "dillivry",
    img_small: dillivrysmall,
    contribution_description:
      "I developed the admin website for Dillivry, focusing on building a comprehensive platform that supports the logistics process from sender assignment to parcel delivery. My role included implementing functionalities for assigning riders, tracking parcels, managing user complaints, and ensuring efficient content management.",
  },
];
